import axios from "axios";

const api = axios.create({
  baseURL: "https://apiflow.cooper.tchat.telnet23.com.br",
});

export default api;
